import { Component, signal } from '@angular/core';

import { demos } from '../../routes';
import {
  DemoContext,
  DemoSources,
  DemoSourceType
} from '../../shared/interfaces';
import { datasourceGetCallbackInfinite } from '../../shared/datasource-get';

import { Datasource } from 'ngx-ui-scroll';

@Component({
  selector: 'app-demo-package-info',
  templateUrl: './package-info.component.html',
  standalone: false
})
export class DemoPackageInfoComponent {
  demoContext: DemoContext = {
    config: demos.adapterProps.map.packageInfo,
    viewportId: 'package-info-viewport',
    count: 0,
    log: signal('')
  };

  datasource = new Datasource({
    get: datasourceGetCallbackInfinite(this.demoContext)
  });

  sources: DemoSources = [
    {
      name: DemoSourceType.Component,
      text: `datasource = new Datasource ({
  get: (index, count, success) => {
    const data = [];
    for (let i = index; i <= index + count - 1; i++) {
      data.push({ id: i, text: 'item #' + i });
    }
    success(data);
  }
});`
    },
    {
      active: true,
      name: DemoSourceType.Template,
      text: `Consumer: {{datasource.adapter.packageInfo.consumer.name}}
v{{datasource.adapter.packageInfo.consumer.version}}
<br>
Core: {{datasource.adapter.packageInfo.core.name}}
v{{datasource.adapter.packageInfo.core.version}}

<div class="viewport">
  <div *uiScroll="let item of datasource">
    <div class="item">{{item.text}}</div>
  </div>
</div>`
    },
    {
      name: DemoSourceType.Styles,
      text: `.viewport {
  width: 150px;
  height: 250px;
  overflow-y: auto;
}
.item {
  font-weight: bold;
  height: 25px;
}`
    }
  ];
}
